export const engagementContentBlocksTags = "/engagement/content_blocks/tags";
